import { IKeyInitiativeSuggestionApi, IMdfActivityApi } from '../api/types'
import { IKeyInitiativeSuggestion, IMdfActivity } from '../model/types'

import { parseSeparatedString } from './parseSeparatedString'
import { parseStrategicInitiativeAllocations } from './parseStrategicInitiativeAllocations'

const parseKeyInitiativeSuggestions = (raw: string | null): IKeyInitiativeSuggestion[] => {
  if (!raw) {
    return []
  }

  try {
    const parsed = JSON.parse(raw) as IKeyInitiativeSuggestionApi[]

    return parsed.map((suggestion) => ({
      keyInitiativeId: suggestion.KeyInitiativeId,
      matchPercent: suggestion.MatchPercent,
    }))
  } catch {
    return []
  }
}

export const mapMdfActivityFromApi = (data: IMdfActivityApi): IMdfActivity => ({
  entryId: Number(data.EntryId),
  created: data.Created,
  createdBy: data.CreatedBy,
  modified: data.Modified,
  modifiedBy: data.ModifiedBy,
  partnerId: data.PartnerID,
  timeframe: data.Timeframe,
  activityId: data.ActivityID,
  activityType: data.ActivityType,
  activityName: data.ActivityName,
  activityStatus: data.ActivityStatus,
  statusCategory: data.StatusCategory,
  p360InitiativeId: data.P360InitiativeId,
  strategicInitiatives: parseSeparatedString(data.StrategicInitiative),
  businessUnit: parseSeparatedString(data.BusinessUnit),
  businessFocus: parseSeparatedString(data.BusinessFocus),
  category: data.Category ?? '',
  strategicInitiativeAllocations: parseStrategicInitiativeAllocations(data.StrategicInitiatives),
  requestedAmountUsd: data.RequestedAmountUSD,
  requestedAmountLc: data.RequestedAmount,
  localCurrency: data.LocalCurrency,
  hpContributionPercent: data.HPContributionPercent,
  claimPaidUsd: data.ClaimPaidUSD,
  claimPaidLc: data.ClaimPaidLC,
  approvalDate: data.ApprovalDate ?? '',
  executionStartDate: data.ExecutionStartDate,
  executionEndDate: data.ExecutionEndDate,
  partnerContactEmails: parseSeparatedString(data.PartnerContactEmail),
  hpContactEmails: parseSeparatedString(data.HPContactEmail),
  keyInitiativeId: data.KeyInitiativeId,
  keyInitiativeMatchPercent: data.KeyInitiativeMatchPercent,
  keyInitiativeSuggestions: parseKeyInitiativeSuggestions(data.KeyInitiativeSuggestions),
  keyInitiativeLinkType: data.KeyInitiativeLinkType,
  outcome: data.Outcome,
  outcomeValueType: data.OutcomeValueType,
  funnelSizeUsd: data.FunnelSize,
  leads: data.Leads,
  conversionRate: data.ConversionRate,
  attendance: data.Attendance,
  estimatedSalesUsd: data.EstimateSales,
})
